export enum GraphQLFetchPolicies {
  CacheFirst = 'cache-first',
  CacheOnly = 'cache-only',
  NetworkOnly = 'network-only',
  CacheAndNetwork = 'cache-and-network',
  NoCache = 'no-cache',
}
